import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
import authenticate from "@/auth/authenticate";
import { investment, mechanism, enterprise } from "@/auth/authView";

const routes = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/components/login"),
    children: [
      {
        path: "Improveinformation",
        name: "Improveinformation",
        component: () => import("@/components/improvein"),
      },
    ],
  },
  {
    path: "/zhuce",
    name: "zhuce",
    component: () => import("@/components/zhuce"),
  },
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/zijian",
    name: "zijian",
    component: () => import("@/view/zijian/index"),
  },
  {
    path: "/zhuce",
    name: "zhuce",
    component: () => import("@/view/zhuce/index"),
  },
  {
    path: "/index",
    component: () => import("@/view/index/index"),
    beforeEnter: authenticate,
    children: [
      //招商人员首页
      {
        path: "investment",
        name: "investment",
        component: () => import("@/view/InvestMent/index"),
        beforeEnter: investment,
        meta: { key:0 },
        children: [
          //线索录入
          {
            path: "home",
            name: "home",
            component: () => import("@/view/InvestMent/index"),
            meta: {  },
          },
          //线索录入
          {
            path: "ClueEntry",
            name: "ClueEntry",
            component: () => import("@/view/InvestMent/children/ClueEntry"),
            meta: {   },
          },
          //项目查询
          {
            path: "ProjectQuery",
            name: "ProjectQuery",
            component: () => import("@/view/InvestMent/children/ProjectQuery"),
            meta: {   },
          },
          //线索查询
          {
            path: "ClueQuery",
            name: "ClueQuery",
            component: () => import("@/view/InvestMent/children/ClueQuery"),
            meta: {  },
          },
          // 线索详情
          {
            path: "MyAudit",
            name: "MyAudit",
            component: () => import("@/view/InvestMent/children/MyAudit"),
          },
          //个人中心
          {
            path: "MyCenter",
            name: "InvestmentMyCenter",
            component: () => import("@/view/MyCenter/index"),
            meta: {  key: 4 },
          },
          //地图展示
          {
            path: "JJmap",
            name: "InvestmentJJmap",
            component: () => import("@/view/JJmap/index"),
            meta: { key:3  },
          },

          //扫一扫
          // {
          //   path: "scan",
          //   name: "Scan",
          //   component: () => import("@/view/InvestMent/children/scan"),
          //   meta: {   },
          // },
          {
            path: "scan",
            name: "Scan",
            component: () => import("@/view/clue/scan"),
            meta: {  key:5},
          },
          //我的线索
          {
            path: "myclue",
            name: "myclue",
            component: () => import("@/view/InvestMent/children/myclue"),
            meta: {  },
          },
          // 风险明细
          {
            path: "ScanDetail",
            name: "ScanDetail",
            component: () => import("@/view/InvestMent/children/ScanDetail"),
            meta: {  },
          },
          // 风险明细详情
          {
            path: "ScanSubDetail",
            name: "ScanSubDetail",
            component: () => import("@/view/InvestMent/children/ScanSubDetail"),
            meta: {  },
          },
          // 企业监控
          {
            path: "CompanyJK",
            name: "CompanyJK",
            component: () => import("@/view/InvestMent/children/CompanyJK"),
          },
          //扫描二维码
          {
            path: "Qcode",
            name: "Qcode",
            component: () => import("@/view/InvestMent/children/Qcode"),
          },
        ],
      },
      {
        path: "investment2",
        name: "investment2",
        component: () => import("@/view/InvestMent/index"),
        beforeEnter: investment,
        meta: { key: 1},
      },
      //企业三方机构
      {
        path: "mechanism",
        name: "mechanism",
        component: () => import("@/view/mechanism"),
        beforeEnter: mechanism,
        children: [
          //线索填报
          {
            path: "ClueEntry",
            name: "ClueEntry",
            component: () => import("@/view/InvestMent/children/ClueEntry"),
          },
          //我的项目
          {
            path: "MyProject",
            name: "MyProject",
            component: () => import("@/view/mechanism/children/MyProject"),
          },
          //产值填报
          {
            path: "OutputValue",
            name: "OutputValue",
            component: () => import("@/view/mechanism/children/OutputValue"),
            children: [
              {
                path: "OutputValueDetails",
                name: "OutputValueDetails",
                component: () =>
                  import("@/view/mechanism/children/OutputValueDetails"),
              },
            ],
          },
          {
            path: "MyCenter",
            name: "mechanismMyCenter",
            component: () => import("@/view/MyCenter/index"),
          },
        ],
      },
      //专家库成员首页
      {
        path: "enterprise",
        name: "enterprise",
        component: () => import("@/view/enterprise"),
        beforeEnter: enterprise,
      },
      //专家库成员项目详情
      {
        path: "ProjectDetails",
        name: "ProjectDetails",
        component: () => import("@/view/enterprise/children/ProjectDetails"),
      },
      //统计
      {
        path: "Statistics",
        name: "Statistics",
        component: () => import("@/view/Statistics"),
        meta: {
           key: 2,
          keepAlive: true, // 需要缓存
        },
      },
      // 企业营收、投产达产情况统计--企业列表
      {
        path: "e10_detial_1",
        name: "e10_detial_1",
        component: () => import("@/view/Statistics/e10_detial_1"),
      },
      // 企业营收、投产达产情况统计--企业详情数据
      {
        path: "e10_detial_2",
        name: "e10_detial_2",
        component: () => import("@/view/Statistics/e10_detial_2"),
      },
      //个人中心
      /*    {
                   path: 'MyCenter',
                   name: 'MyCenter',
                   component: () => import('@/view/MyCenter/index')
               }, */
      //个人中心-修改密码
      {
        path: "changePassword",
        name: "changePassword",
        component: () => import("@/view/MyCenter/changePassword"),
      },
      //个人中心-修改电子邮件
      {
        path: "changeMail",
        name: "changeMail",
        component: () => import("@/view/MyCenter/changeMail"),
      },
      //个人中心-修改手机1
      {
        path: "changePhone1",
        name: "changePhone1",
        component: () => import("@/view/MyCenter/changePhone1"),
      },
      //个人中心-修改手机2
      {
        path: "changePhone2",
        name: "changePhone2",
        component: () => import("@/view/MyCenter/changePhone2"),
      },
      {
        path: "NewsList",
        name: "NewsList",
        component: () => import("@/view/NewList"),
      },
      {
        path: "NewsListDetails/:id",
        name: "NewsListDetails",
        component: () => import("@/view/NewList/children"),
      },
      {
        path: "NoticeList",
        name: "NoticeList",
        component: () => import("@/view/NoticeList"),
      },
      {
        path: "NoticeListDetails",
        name: "NoticeListDetails",
        component: () => import("@/view/NoticeList/children"),
      },
      {
        path: "clueDetail",
        name: "clueDetail",
        component: () => import("@/view/clue/detail"),
      },
      {
        path: "myclueDetail",
        name: "myclueDetail",
        component: () => import("@/view/clue/mydetail"),
      },
      {
        path: "pdf",
        name: "pdf",
        component: () => import("@/view/clue/pdf"),
      },
      {
        path: "map",
        name: "map",
        component: () => import("@/view/clue/map"),
      },
      {
        path: "cluehtml",
        name: "cluehtml",
        component: () => import("@/view/clue/cluehtml"),
      },
      {
        path: "jiluhtml",
        name: "jiluhtml",
        component: () => import("@/view/clue/jiluhtml"),
      },
      {
        path: "mycluehtml",
        name: "mycluehtml",
        component: () => import("@/view/clue/mycluehtml"),
      },
      {
        path: "clueQueryhtml",
        name: "clueQueryhtml",
        component: () => import("@/view/clue/clueQueryhtml"),
      },
      {
        path: "CluelistEdit",
        name: "CluelistEdit",
        component: () => import("@/view/clue/CluelistEdit"),
      },
      {
        path: "xsclueQueryhtml",
        name: "xsclueQueryhtml",
        component: () => import("@/view/clue/xsclueQueryhtml"),
      },
      {
        path: "twocode",
        name: "twocode",
        component: () => import("@/view/clue/twocode"),
      },
      {
        path: "fourimg",
        name: "fourimg",
        component: () => import("@/view/clue/fourimg"),
      },
      //项目详情
      {
        path: "programDetail",
        name: "programDetail",
        component: () => import("@/view/programDetail/index"),
      },
      {
        path: "process",
        name: "process",
        component: () => import("@/view/programDetail/children/process"),
      },
      {
        path: "comprehensive",
        name: "comprehensive",
        component: () => import("@/view/programDetail/children/comprehensive"),
      },
      {
        path: "landing",
        name: "landing",
        component: () => import("@/view/programDetail/children/landing"),
      },
      {
        path: "meeting",
        name: "meeting",
        component: () => import("@/view/programDetail/children/meeting"),
      },
      {
        path: "opinion",
        name: "opinion",
        component: () => import("@/view/programDetail/children/opinion"),
      },
      {
        path: "evaluation",
        name: "evaluation",
        component: () => import("@/view/programDetail/children/evaluation"),
      },
      {
        path: "survey",
        name: "survey",
        component: () => import("@/view/programDetail/children/survey"),
      },
      {
        path: "analysis",
        name: "analysis",
        component: () => import("@/view/programDetail/children/analysis"),
      },
      {
        path: "projectInformation",
        name: "projectInformation",
        component: () =>
          import("@/view/programDetail/children/projectInformation"),
      },
      {
        path: "enterpriseInformation",
        name: "enterpriseInformation",
        component: () =>
          import("@/view/programDetail/children/enterpriseInformation"),
      },
      {
        path: "carrier",
        name: "carrier",
        component: () => import("@/view/programDetail/children/carrier"),
      },
      {
        path: "finance",
        name: "finance",
        component: () => import("@/view/programDetail/children/finance"),
      },
      //扫描二维码
      {
        path: "Qcode",
        name: "Qcode",
        component: () => import("@/view/InvestMent/children/Qcode"),
      },
    ],
  },
  {
    path: "/author",
    name: "author",
    component: () => import("@/view/weixin/author"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.afterEach(() => {
  let currentPosition, timer;
  timer = setInterval(function () {
    currentPosition =
      document.documentElement.scrollTop || document.body.scrollTop;
    currentPosition -= 30;
    if (currentPosition > 0) {
      window.scrollTo(0, currentPosition);
    } else {
      window.scrollTo(0, 0);
      clearInterval(timer);
    }
  }, 1);
});

export default router;
